export const countryMapList = {
  0: {
    name: "Hong Kong",
    id: 0,
    dialCode: "+852",
    wisenetCode: "",
    isoCode: "hk",
  },
  1: {
    name: "Afghanistan",
    id: 1,
    dialCode: "+93",
    wisenetCode: "7201",
    isoCode: "af",
  },
  2: {
    name: "Angola",
    id: 2,
    dialCode: "+244",
    wisenetCode: "9201",
    isoCode: "ao",
  },
  3: {
    name: "Albania",
    id: 3,
    dialCode: "+355",
    wisenetCode: "3201",
    isoCode: "al",
  },
  4: {
    name: "Andorra",
    id: 4,
    dialCode: "+376",
    wisenetCode: "3101",
    isoCode: "ad",
  },
  5: {
    name: "United Arab Emirates",
    id: 5,
    dialCode: "+971",
    wisenetCode: "4216",
    isoCode: "ae",
  },
  6: {
    name: "Argentina",
    id: 6,
    dialCode: "+54",
    wisenetCode: "8201",
    isoCode: "ar",
  },
  7: {
    name: "Armenia",
    id: 7,
    dialCode: "+374",
    wisenetCode: "7202",
    isoCode: "am",
  },
  8: {
    name: "Antigua and Barbuda",
    id: 8,
    dialCode: "+1268",
    wisenetCode: "8402",
    isoCode: "ag",
  },
  9: {
    name: "Australia",
    id: 9,
    dialCode: "+61",
    wisenetCode: "1101",
    isoCode: "au",
  },
  10: {
    name: "Austria",
    id: 10,
    dialCode: "+43",
    wisenetCode: "2301",
    isoCode: "at",
  },
  11: {
    name: "Azerbaijan",
    id: 11,
    dialCode: "+994",
    wisenetCode: "7203",
    isoCode: "az",
  },
  12: {
    name: "Burundi",
    id: 12,
    dialCode: "+257",
    wisenetCode: "9203",
    isoCode: "bi",
  },
  13: {
    name: "Belgium",
    id: 13,
    dialCode: "+32",
    wisenetCode: "2302",
    isoCode: "be",
  },
  14: {
    name: "Benin",
    id: 14,
    dialCode: "+229",
    wisenetCode: "9101",
    isoCode: "bj",
  },
  15: {
    name: "Burkina Faso",
    id: 15,
    dialCode: "+226",
    wisenetCode: "9102",
    isoCode: "bf",
  },
  16: {
    name: "Bangladesh",
    id: 16,
    dialCode: "+880",
    wisenetCode: "7101",
    isoCode: "bd",
  },
  17: {
    name: "Bulgaria",
    id: 17,
    dialCode: "+359",
    wisenetCode: "3203",
    isoCode: "bg",
  },
  18: {
    name: "Bahrain",
    id: 18,
    dialCode: "+973",
    wisenetCode: "4201",
    isoCode: "bh",
  },
  19: {
    name: "Bahamas",
    id: 19,
    dialCode: "+1242",
    wisenetCode: "8404",
    isoCode: "bs",
  },
  20: {
    name: "Bosnia and Herzegovina",
    id: 20,
    dialCode: "+387",
    wisenetCode: "3202",
    isoCode: "ba",
  },
  21: {
    name: "Belarus",
    id: 21,
    dialCode: "+375",
    wisenetCode: "3301",
    isoCode: "by",
  },
  22: {
    name: "Belize",
    id: 22,
    dialCode: "+501",
    wisenetCode: "8301",
    isoCode: "bz",
  },
  23: {
    name: "Bolivia",
    id: "23",
    dialCode: "+591",
    wisenetCode: "8202",
    isoCode: "bo",
  },
  24: {
    name: "Brazil",
    id: 24,
    dialCode: "+55",
    wisenetCode: "8203",
    isoCode: "br",
  },
  25: {
    name: "Barbados",
    id: 25,
    dialCode: "+1246",
    wisenetCode: "8405",
    isoCode: "bb",
  },
  26: {
    name: "Brunei Darussalam",
    id: 26,
    dialCode: "+673",
    wisenetCode: "5201",
    isoCode: "bn",
  },
  27: {
    name: "Bhutan",
    id: 27,
    dialCode: "+975",
    wisenetCode: "7102",
    isoCode: "bt",
  },
  28: {
    name: "Botswana",
    id: 28,
    dialCode: "+267",
    wisenetCode: "9202",
    isoCode: "bw",
  },
  29: {
    name: "Central African Republic",
    id: 29,
    dialCode: "+236",
    wisenetCode: "9105",
    isoCode: "cf",
  },
  30: {
    name: "Canada",
    id: 30,
    dialCode: "+1",
    wisenetCode: "8102",
    isoCode: "ca",
  },
  31: {
    name: "Switzerland",
    id: 31,
    dialCode: "+41",
    wisenetCode: "2311",
    isoCode: "ch",
  },
  32: {
    name: "Chile",
    id: 32,
    dialCode: "+56",
    wisenetCode: "8204",
    isoCode: "cl",
  },
  33: {
    name: "China",
    id: 33,
    dialCode: "+86",
    wisenetCode: "6101",
    isoCode: "tw",
  },
  34: {
    name: "Ivory Coast",
    id: "34",
    dialCode: "+225",
    wisenetCode: "9111",
  },
  35: {
    name: "Cameroon",
    id: 35,
    dialCode: "+237",
    wisenetCode: "9103",
    isoCode: "cm",
  },
  36: {
    name: "Democratic Republic of the Congo",
    id: "36",
    dialCode: "+243",
    wisenetCode: "9108",
  },
  37: {
    name: "People's Republic of the Congo",
    id: "37",
    dialCode: "+242",
    wisenetCode: "9107",
  },
  38: {
    name: "Colombia",
    id: 38,
    dialCode: "+57",
    wisenetCode: "8205",
    isoCode: "co",
  },
  39: {
    name: "Comoros",
    id: 39,
    dialCode: "+269",
    wisenetCode: "9204",
    isoCode: "km",
  },
  40: {
    name: "CapeVerde",
    id: "40",
    dialCode: "+238",
    wisenetCode: "9104",
  },
  41: {
    name: "Costa Rica",
    id: 41,
    dialCode: "+506",
    wisenetCode: "8302",
    isoCode: "cr",
  },
  42: {
    name: "Cuba",
    id: 42,
    dialCode: "+53",
    wisenetCode: "8407",
    isoCode: "cu",
  },
  43: {
    name: "Cyprus",
    id: 43,
    dialCode: "+357",
    wisenetCode: "3205",
    isoCode: "cy",
  },
  44: {
    name: "Czech Republic",
    id: 44,
    dialCode: "+420",
    wisenetCode: "3302",
    isoCode: "cz",
  },
  45: {
    name: "Germany",
    id: 45,
    dialCode: "+49",
    wisenetCode: "2304",
    isoCode: "de",
  },
  46: {
    name: "Djibouti",
    id: 46,
    dialCode: "+253",
    wisenetCode: "9205",
    isoCode: "dj",
  },
  47: {
    name: "Dominica",
    id: 47,
    dialCode: "+1767",
    wisenetCode: "8408",
    isoCode: "do",
  },
  48: {
    name: "Denmark",
    id: 48,
    dialCode: "+45",
    wisenetCode: "2401",
    isoCode: "dk",
  },
  49: {
    name: "Dominican Republic",
    id: 49,
    dialCode: "+1",
    wisenetCode: "8411",
    isoCode: "do",
  },
  50: {
    name: "Algeria",
    id: 50,
    dialCode: "+213",
    wisenetCode: "4101",
    isoCode: "dz",
  },
  51: {
    name: "Ecuador",
    id: 51,
    dialCode: "+593",
    wisenetCode: "8206",
    isoCode: "ec",
  },
  52: {
    name: "Egypt",
    id: 52,
    dialCode: "+20",
    wisenetCode: "4102",
    isoCode: "eg",
  },
  53: {
    name: "Eritrea",
    id: 53,
    dialCode: "+291",
    wisenetCode: "9206",
    isoCode: "er",
  },
  55: {
    name: "Spain",
    id: 55,
    dialCode: "+34",
    wisenetCode: "3108",
    isoCode: "es",
  },
  56: {
    name: "Estonia",
    id: 56,
    dialCode: "+372",
    wisenetCode: "3303",
    isoCode: "ee",
  },
  57: {
    name: "Ethiopia",
    id: 57,
    dialCode: "+251",
    wisenetCode: "9207",
    isoCode: "et",
  },
  58: {
    name: "Finland",
    id: 58,
    dialCode: "+358",
    wisenetCode: "2403",
    isoCode: "fi",
  },
  59: {
    name: "Fiji",
    id: 59,
    dialCode: "+679",
    wisenetCode: "1502",
    isoCode: "fj",
  },
  60: {
    name: "France",
    id: 60,
    dialCode: "+33",
    wisenetCode: "2303",
    isoCode: "fr",
  },
  61: {
    name: "Micronesia",
    id: "61",
    dialCode: "+691",
    wisenetCode: "1404",
    isoCode: "fm",
  },
  62: {
    name: "Gabon",
    id: 62,
    dialCode: "+241",
    wisenetCode: "9113",
    isoCode: "ga",
  },
  63: {
    name: "United Kingdom",
    id: 63,
    dialCode: "+44",
    wisenetCode: "2100",
    isoCode: "gb",
  },
  64: {
    name: "Georgia",
    id: 64,
    dialCode: "+995",
    wisenetCode: "7204",
    isoCode: "gs",
  },
  65: {
    name: "Ghana",
    id: 65,
    dialCode: "+233",
    wisenetCode: "9115",
    isoCode: "gh",
  },
  66: {
    name: "Guinea",
    id: 66,
    dialCode: "+224",
    wisenetCode: "9116",
    isoCode: "pg",
  },
  67: {
    name: "Gambia",
    id: 67,
    dialCode: "+220",
    wisenetCode: "9114",
    isoCode: "gm",
  },
  68: {
    name: "Guinea-Bissau",
    id: 68,
    dialCode: "+245",
    wisenetCode: "9117",
    isoCode: "gw",
  },
  69: {
    name: "Equatorial Guinea",
    id: 69,
    dialCode: "+240",
    wisenetCode: "9112",
    isoCode: "gq",
  },
  70: {
    name: "Greece",
    id: 70,
    dialCode: "+30",
    wisenetCode: "3207",
    isoCode: "gr",
  },
  71: {
    name: "Grenada",
    id: 71,
    dialCode: "+1473",
    wisenetCode: "8412",
    isoCode: "gd",
  },
  72: {
    name: "Guatemala",
    id: 72,
    dialCode: "+502",
    wisenetCode: "8304",
    isoCode: "gt",
  },
  73: {
    name: "Guyana",
    id: 73,
    dialCode: "+592",
    wisenetCode: "8211",
    isoCode: "gy",
  },
  74: {
    name: "Honduras",
    id: 74,
    dialCode: "+504",
    wisenetCode: "8305",
    isoCode: "hn",
  },
  75: {
    name: "Croatia",
    id: 75,
    dialCode: "+385",
    wisenetCode: "3204",
    isoCode: "hr",
  },
  76: {
    name: "Haiti",
    id: 76,
    dialCode: "+509",
    wisenetCode: "8414",
    isoCode: "ht",
  },
  77: {
    name: "Hungary",
    id: 77,
    dialCode: "+36",
    wisenetCode: "3304",
    isoCode: "hu",
  },
  78: {
    name: "Indonesia",
    id: 78,
    dialCode: "+62",
    wisenetCode: "5202",
    isoCode: "id",
  },
  79: {
    name: "India",
    id: 79,
    dialCode: "+91",
    wisenetCode: "7103",
    isoCode: "in",
  },
  80: {
    name: "Ireland",
    id: 80,
    dialCode: "+353",
    wisenetCode: "2201",
    isoCode: "ie",
  },
  81: {
    name: "Iran",
    id: "81",
    dialCode: "+98",
    wisenetCode: "4203",
    isoCode: "ir",
  },
  82: {
    name: "Iraq",
    id: 82,
    dialCode: "+964",
    wisenetCode: "4204",
    isoCode: "iq",
  },
  83: {
    name: "Iceland",
    id: 83,
    dialCode: "+354",
    wisenetCode: "2405",
    isoCode: "is",
  },
  84: {
    name: "Israel",
    id: 84,
    dialCode: "+972",
    wisenetCode: "4205",
    isoCode: "il",
  },
  85: {
    name: "Italy",
    id: 85,
    dialCode: "+39",
    wisenetCode: "3104",
    isoCode: "it",
  },
  86: {
    name: "Jamaica",
    id: 86,
    dialCode: "+1876",
    wisenetCode: "8415",
    isoCode: "jm",
  },
  87: {
    name: "Jordan",
    id: 87,
    dialCode: "+962",
    wisenetCode: "4206",
    isoCode: "jo",
  },
  88: {
    name: "Japan",
    id: 88,
    dialCode: "+81",
    wisenetCode: "6201",
    isoCode: "jp",
  },
  89: {
    name: "Kazakhstan",
    id: 89,
    dialCode: "+77",
    wisenetCode: "7205",
    isoCode: "kz",
  },
  90: {
    name: "Kenya",
    id: 90,
    dialCode: "+254",
    wisenetCode: "9208",
    isoCode: "ke",
  },
  91: {
    name: "Kyrgyzstan",
    id: 91,
    dialCode: "+996",
    wisenetCode: "7206",
    isoCode: "kg",
  },
  92: {
    name: "Cambodia",
    id: 92,
    dialCode: "+855",
    wisenetCode: "5102",
    isoCode: "kh",
  },
  93: {
    name: "Kiribati",
    id: 93,
    dialCode: "+686",
    wisenetCode: "1402",
    isoCode: "ki",
  },
  94: {
    name: "Saint Kitts and Nevis",
    id: 94,
    dialCode: "+1869",
    wisenetCode: "8422",
    isoCode: "kn",
  },
  95: {
    name: "Republic of Korea (South)",
    id: "95",
    dialCode: "+82",
    wisenetCode: "6203",
    isoCode: "kr",
  },
  96: {
    name: "Kuwait",
    id: 96,
    dialCode: "+965",
    wisenetCode: "4207",
    isoCode: "kw",
  },
  97: {
    name: "Lao People's Democratic Republic",
    id: "97",
    dialCode: "+856",
    wisenetCode: "5103",
    isoCode: "la",
  },
  98: {
    name: "Lebanon",
    id: 98,
    dialCode: "+961",
    wisenetCode: "4208",
    isoCode: "lb",
  },
  99: {
    name: "Liberia",
    id: 99,
    dialCode: "+231",
    wisenetCode: "9118",
    isoCode: "lr",
  },
  100: {
    name: "Libya",
    id: 100,
    dialCode: "+218",
    wisenetCode: "4103",
    isoCode: "ly",
  },
  101: {
    name: "Saint Lucia",
    id: 101,
    dialCode: "+1758",
    wisenetCode: "8423",
    isoCode: "lc",
  },
  102: {
    name: "Liechtenstein",
    id: 102,
    dialCode: "+423",
    wisenetCode: "2305",
    isoCode: "li",
  },
  103: {
    name: "Sri Lanka",
    id: 103,
    dialCode: "+94",
    wisenetCode: "7107",
    isoCode: "lk",
  },
  104: {
    name: "Lesotho",
    id: 104,
    dialCode: "+266",
    wisenetCode: "9211",
    isoCode: "ls",
  },
  105: {
    name: "Lithuania",
    id: 105,
    dialCode: "+370",
    wisenetCode: "3306",
    isoCode: "lt",
  },
  106: {
    name: "Luxembourg",
    id: 106,
    dialCode: "+352",
    wisenetCode: "2306",
    isoCode: "lu",
  },
  107: {
    name: "Latvia",
    id: 107,
    dialCode: "+371",
    wisenetCode: "3305",
    isoCode: "lv",
  },
  108: {
    name: "Morocco",
    id: 108,
    dialCode: "+212",
    wisenetCode: "4104",
    isoCode: "ma",
  },
  109: {
    name: "Monaco",
    id: 109,
    dialCode: "+377",
    wisenetCode: "2307",
    isoCode: "mc",
  },
  110: {
    name: "Moldova",
    id: "110",
    dialCode: "+373",
    wisenetCode: "3208",
    isoCode: "md",
  },
  111: {
    name: "Madagascar",
    id: 111,
    dialCode: "+261",
    wisenetCode: "9212",
    isoCode: "mg",
  },
  112: {
    name: "Maldives",
    id: 112,
    dialCode: "+960",
    wisenetCode: "7104",
    isoCode: "mv",
  },
  113: {
    name: "Mexico",
    id: 113,
    dialCode: "+52",
    wisenetCode: "8306",
    isoCode: "mx",
  },
  114: {
    name: "Marshall Islands",
    id: 114,
    dialCode: "+692",
    wisenetCode: "1403",
    isoCode: "mh",
  },
  115: {
    name: "Macedonia",
    id: "115",
    dialCode: "+389",
    wisenetCode: "3206",
    isoCode: "mk",
  },
  116: {
    name: "Mali",
    id: 116,
    dialCode: "+223",
    wisenetCode: "9121",
    isoCode: "ml",
  },
  117: {
    name: "Malta",
    id: 117,
    dialCode: "+356",
    wisenetCode: "3105",
    isoCode: "mt",
  },
  118: {
    name: "Myanmar (Burma)",
    id: "118",
    dialCode: "+95",
    wisenetCode: "5101",
    isoCode: "mm",
  },
  119: {
    name: "Montenegro",
    id: 119,
    dialCode: "+382",
    wisenetCode: "3214",
    isoCode: "me",
  },
  120: {
    name: "Mongolia",
    id: 120,
    dialCode: "+976",
    wisenetCode: "6104",
    isoCode: "mn",
  },
  121: {
    name: "Mozambique",
    id: 121,
    dialCode: "+258",
    wisenetCode: "9216",
    isoCode: "mz",
  },
  122: {
    name: "Mauritania",
    id: 122,
    dialCode: "+222",
    wisenetCode: "9122",
    isoCode: "mr",
  },
  123: {
    name: "Mauritius",
    id: 123,
    dialCode: "+230",
    wisenetCode: "9214",
    isoCode: "mu",
  },
  124: {
    name: "Malawi",
    id: 124,
    dialCode: "+265",
    wisenetCode: "9213",
    isoCode: "mw",
  },
  125: {
    name: "Malaysia",
    id: 125,
    dialCode: "+60",
    wisenetCode: "5203",
    isoCode: "my",
  },
  126: {
    name: "Namibia",
    id: 126,
    dialCode: "+264",
    wisenetCode: "9217",
    isoCode: "na",
  },
  127: {
    name: "Niger",
    id: 127,
    dialCode: "+227",
    wisenetCode: "9123",
    isoCode: "ng",
  },
  128: {
    name: "Nigeria",
    id: 128,
    dialCode: "+234",
    wisenetCode: "9124",
    isoCode: "ng",
  },
  129: {
    name: "Nicaragua",
    id: 129,
    dialCode: "+505",
    wisenetCode: "8307",
    isoCode: "ni",
  },
  130: {
    name: "Netherlands",
    id: 130,
    dialCode: "+31",
    wisenetCode: "2308",
    isoCode: "nl",
  },
  131: {
    name: "Norway",
    id: 131,
    dialCode: "+47",
    wisenetCode: "2406",
    isoCode: "no",
  },
  132: {
    name: "Nepal",
    id: 132,
    dialCode: "+977",
    wisenetCode: "7105",
    isoCode: "np",
  },
  133: {
    name: "Nauru",
    id: 133,
    dialCode: "+674",
    wisenetCode: "1405",
    isoCode: "nr",
  },
  134: {
    name: "New Zealand",
    id: 134,
    dialCode: "+64",
    wisenetCode: "1201",
    isoCode: "nz",
  },
  135: {
    name: "Oman",
    id: 135,
    dialCode: "+968",
    wisenetCode: "4211",
    isoCode: "om",
  },
  136: {
    name: "Pakistan",
    id: 136,
    dialCode: "+92",
    wisenetCode: "7106",
    isoCode: "pk",
  },
  137: {
    name: "Panama",
    id: 137,
    dialCode: "+507",
    wisenetCode: "8308",
    isoCode: "pa",
  },
  138: {
    name: "Peru",
    id: 138,
    dialCode: "+51",
    wisenetCode: "8213",
    isoCode: "pe",
  },
  139: {
    name: "Philippines",
    id: 139,
    dialCode: "+63",
    wisenetCode: "5204",
    isoCode: "ph",
  },
  140: {
    name: "Palau",
    id: 140,
    dialCode: "+680",
    wisenetCode: "1407",
    isoCode: "pw",
  },
  141: {
    name: "Papua New Guinea",
    id: 141,
    dialCode: "+675",
    wisenetCode: "1302",
    isoCode: "pg",
  },
  142: {
    name: "Poland",
    id: 142,
    dialCode: "+48",
    wisenetCode: "3307",
    isoCode: "pl",
  },
  143: {
    name: "Portugal",
    id: 143,
    dialCode: "+351",
    wisenetCode: "3106",
    isoCode: "pt",
  },
  144: {
    name: "Paraguay",
    id: 144,
    dialCode: "+595",
    wisenetCode: "8212",
    isoCode: "py",
  },
  146: {
    name: "Qatar",
    id: 146,
    dialCode: "+974",
    wisenetCode: "4212",
    isoCode: "qa",
  },
  147: {
    name: "Romania",
    id: 147,
    dialCode: "+40",
    wisenetCode: "3211",
    isoCode: "ro",
  },
  148: {
    name: "Russia",
    id: "148",
    dialCode: "+7",
    wisenetCode: "3308",
    isoCode: "ru",
  },
  149: {
    name: "Rwanda",
    id: 149,
    dialCode: "+250",
    wisenetCode: "9221",
    isoCode: "rw",
  },
  150: {
    name: "Saudi Arabia",
    id: 150,
    dialCode: "+966",
    wisenetCode: "4213",
    isoCode: "sa",
  },
  151: {
    name: "Sudan",
    id: 151,
    dialCode: "+249",
    wisenetCode: "4105",
    isoCode: "sd",
  },
  152: {
    name: "Senegal",
    id: 152,
    dialCode: "+221",
    wisenetCode: "9126",
    isoCode: "sn",
  },
  153: {
    name: "Singapore",
    id: 153,
    dialCode: "+65",
    wisenetCode: "5205",
    isoCode: "sg",
  },
  154: {
    name: "Solomon Islands",
    id: 154,
    dialCode: "+677",
    wisenetCode: "1303",
    isoCode: "sb",
  },
  155: {
    name: "Sierra Leone",
    id: 155,
    dialCode: "+232",
    wisenetCode: "9127",
    isoCode: "sl",
  },
  156: {
    name: "El Salvador",
    id: 156,
    dialCode: "+503",
    wisenetCode: "8303",
    isoCode: "sv",
  },
  157: {
    name: "San Marino",
    id: 157,
    dialCode: "+378",
    wisenetCode: "3107",
    isoCode: "sm",
  },
  158: {
    name: "Somalia",
    id: 158,
    dialCode: "+252",
    wisenetCode: "9224",
    isoCode: "so",
  },
  159: {
    name: "Serbia",
    id: 159,
    dialCode: "+381",
    wisenetCode: "3215",
    isoCode: "rs",
  },
  160: {
    name: "Sao Tomé and Principe",
    id: "160",
    dialCode: "+239",
    wisenetCode: "9125",
  },
  161: {
    name: "Suriname",
    id: 161,
    dialCode: "+597",
    wisenetCode: "8214",
    isoCode: "sr",
  },
  162: {
    name: "Slovakia",
    id: 162,
    dialCode: "+421",
    wisenetCode: "3311",
    isoCode: "sk",
  },
  163: {
    name: "Slovenia",
    id: 163,
    dialCode: "+386",
    wisenetCode: "3212",
    isoCode: "si",
  },
  164: {
    name: "Sweden",
    id: 164,
    dialCode: "+46",
    wisenetCode: "2407",
    isoCode: "se",
  },
  165: {
    name: "Swaziland",
    id: 165,
    dialCode: "+268",
    wisenetCode: "9226",
    isoCode: "sz",
  },
  166: {
    name: "Seychelles",
    id: 166,
    dialCode: "+248",
    wisenetCode: "9223",
    isoCode: "sc",
  },
  167: {
    name: "Syrian Arab Republic",
    id: 167,
    dialCode: "+963",
    wisenetCode: "4214",
    isoCode: "sy",
  },
  168: {
    name: "Chad",
    id: 168,
    dialCode: "+235",
    wisenetCode: "9106",
    isoCode: "td",
  },
  169: {
    name: "Togo",
    id: 169,
    dialCode: "+228",
    wisenetCode: "9128",
    isoCode: "tg",
  },
  170: {
    name: "Thailand",
    id: 170,
    dialCode: "+66",
    wisenetCode: "5104",
    isoCode: "th",
  },
  171: {
    name: "Tajikistan",
    id: 171,
    dialCode: "+992",
    wisenetCode: "7207",
    isoCode: "tj",
  },
  172: {
    name: "Turkmenistan",
    id: 172,
    dialCode: "+993",
    wisenetCode: "7208",
    isoCode: "tm",
  },
  173: {
    name: "Timor-Leste",
    id: 173,
    dialCode: "+670",
    wisenetCode: "5206",
    isoCode: "tl",
  },
  174: {
    name: "Tonga",
    id: 174,
    dialCode: "+676",
    wisenetCode: "1508",
    isoCode: "to",
  },
  175: {
    name: "Trinidad and Tobago",
    id: 175,
    dialCode: "+1868",
    wisenetCode: "8425",
    isoCode: "tt",
  },
  176: {
    name: "Tunisia",
    id: 176,
    dialCode: "+216",
    wisenetCode: "4106",
    isoCode: "tn",
  },
  177: {
    name: "Turkey",
    id: 177,
    dialCode: "+90",
    wisenetCode: "4215",
    isoCode: "tr",
  },
  178: {
    name: "Tuvalu",
    id: 178,
    dialCode: "+688",
    wisenetCode: "1511",
    isoCode: "tv",
  },
  179: {
    name: "Taiwan",
    id: "179",
    dialCode: "+886",
    wisenetCode: "6105",
    isoCode: "tw",
  },
  180: {
    name: "Tanzania",
    id: "180",
    dialCode: "+255",
    wisenetCode: "9227",
    isoCode: "tz",
  },
  181: {
    name: "Uganda",
    id: 181,
    dialCode: "+256",
    wisenetCode: "9228",
    isoCode: "ug",
  },
  182: {
    name: "Ukraine",
    id: 182,
    dialCode: "+380",
    wisenetCode: "3312",
    isoCode: "ua",
  },
  183: {
    name: "Uruguay",
    id: 183,
    dialCode: "+598",
    wisenetCode: "8215",
    isoCode: "uy",
  },
  184: {
    name: "United States of America",
    id: 184,
    dialCode: "+1",
    wisenetCode: "8104",
    isoCode: "us",
  },
  185: {
    name: "Uzbekistan",
    id: 185,
    dialCode: "+998",
    wisenetCode: "7211",
    isoCode: "uz",
  },
  186: {
    name: "Vatican City",
    id: "186",
    dialCode: "+379",
    wisenetCode: "3103",
    isoCode: "va",
  },
  187: {
    name: "Saint Vincent and the Grenadines",
    id: "187",
    dialCode: "+1784",
    wisenetCode: "8424",
    isoCode: "vc",
  },
  188: {
    name: "Venezuela",
    id: "188",
    dialCode: "+58",
    wisenetCode: "8216",
    isoCode: "ve",
  },
  189: {
    name: "Vietnam",
    id: 189,
    dialCode: "+84",
    wisenetCode: "5105",
    isoCode: "vn",
  },
  190: {
    name: "Vanuatu",
    id: 190,
    dialCode: "+678",
    wisenetCode: "1304",
    isoCode: "vu",
  },
  191: {
    name: "Samoa",
    id: 191,
    dialCode: "+685",
    wisenetCode: "1505",
    isoCode: "ws",
  },
  192: {
    name: "Yemen",
    id: 192,
    dialCode: "+967",
    wisenetCode: "4217",
    isoCode: "ye",
  },
  193: {
    name: "South Africa",
    id: 193,
    dialCode: "+27",
    wisenetCode: "9225",
    isoCode: "za",
  },
  194: {
    name: "Zambia",
    id: 194,
    dialCode: "+260",
    wisenetCode: "9231",
    isoCode: "zm",
  },
  195: {
    name: "Zimbabwe",
    id: 195,
    dialCode: "+263",
    wisenetCode: "9232",
    isoCode: "zw",
  },
  197: {
    name: "South Sudan",
    id: 197,
    dialCode: "+211",
    wisenetCode: "4111",
    isoCode: "ss",
  },
  10001: {
    name: "Democratic People's Republic of Korea (North)",
    id: 10001,
    dialCode: "+850",
    wisenetCode: "",
    isoCode: "kp",
  },
  10002: {
    name: "Kosovo",
    id: 10002,
    dialCode: "+383",
    wisenetCode: "",
  },
  10003: {
    name: "Palestine",
    id: 10003,
    dialCode: "+970",
    wisenetCode: "",
    isoCode: "ps",
  },
  10004: {
    name: "Curaçao",
    id: 10004,
    dialCode: "+599",
    wisenetCode: "",
    isoCode: "cw",
  },
};
